import { render, staticRenderFns } from "./Portals.vue?vue&type=template&id=058e11f1&scoped=true&"
import script from "./Portals.vue?vue&type=script&lang=js&"
export * from "./Portals.vue?vue&type=script&lang=js&"
import style0 from "./Portals.vue?vue&type=style&index=0&id=058e11f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e11f1",
  null
  
)

export default component.exports